module.exports = __webpack_public_path__ + "static/media/vegetariano.4086869b.png";